const BASE_URL = 'api/ai-counters'

const aiCountersRequests = {
  getAiCounterInfoRequest: (data) => ({
    url: `${BASE_URL}/get-ai-counter-info`,
    method: 'post',
    data,
  }),
  getAiCounterInfoByFormRecordRequest: (data) => ({
    url: `${BASE_URL}/get-ai-counter-info-by-form-record`,
    method: 'post',
    data,
  }),
  getAiObjectsCountRequest: (data) => ({
    url: `${BASE_URL}/get-ai-objects-count`,
    method: 'post',
    data,
  }),
}

export default aiCountersRequests
